import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrHostResponseTimeBucketSelf.ts
var t = () => e("hostResponseTimeBucketSelf");
//#endregion
export { t as useTrHostResponseTimeBucketSelf };
